<div class="driver-details" *ngIf="passengerDetails !== null">
  <div>
    <div class="grid">
    <div class="col-12 md:col-3 lg:col-3 sm:col-12">
      <img  class="user-pic user-pic-sm w-120" src="{{imageUrl}}"
        onerror="src='/assets/images/temp/default_profile.png'" />
      <p-rating [ngModel]="Rating" readonly="true" stars="5" class="text-xl"></p-rating>
    </div>
    <div class="col-12 md:col-9 lg:col-9">
      <div class="word-break">
        <!-- <div class="p-col-12">
          <div class="info-label" translate>label_passenger_details_header</div>
        </div> -->

        <div class="journey-details-row">
          <span class="journey-details-label" translate>label_name</span>
          <span class="journey-details-value">{{passengerDetails.firstName }} {{ passengerDetails.lastName}}</span>
        </div>

        <div class="journey-details-row" *ngIf="passengerDetails.numCountryCode && passengerDetails.phoneNum">
          <span class="journey-details-label" translate>label_phone_no</span>
          <span class="journey-details-value">{{passengerDetails.numCountryCode}} {{ passengerDetails.phoneNum }}</span>
        </div>
        <div class="journey-details-row" *ngIf="passengerDetails.email">
          <span class="journey-details-label" translate>label_email</span>
          <span class="journey-details-value">{{ passengerDetails.email }}</span>
        </div>
        <div class="journey-details-row" *ngIf='passengerDetails.rating !== null && passengerDetails.rating > 0'>
          <span class="journey-details-label" translate>rating_col</span>
          <span class="journey-details-value">{{ passengerDetails.passengerRating }}</span>
        </div>

        <div class="grid col-12"
          *ngIf='passengerDetails.addressLine1 !== null && passengerDetails.addressLine1 !== undefined && passengerDetails.addressLine1 !== ""'>
          <div class="col-5">
            <div class="info-label" translate>address_col</div>
          </div>
          <div class="col-7">
            <div>
              <span>{{ passengerDetails.addressLine1 }}</span>
              <span
                *ngIf='passengerDetails.addressLine2!== null && passengerDetails.addressLine2!== undefined && passengerDetails.addressLine2 !== ""'>
                {{passengerDetails.addressLine2}}
              </span>
              <span *ngIf='city !== "" && city !== undefined'>, {{city}}</span>
              <span>, {{country}}</span>
              <span>, {{passengerDetails.zipcode}}</span>
            </div>

          </div>
        </div>

          <div class="journey-details-row" *ngIf='bookingsCount !== null'>
            <span class="journey-details-label" translate>label_no_of_bookings</span>
            <span class="journey-details-value">{{ bookingsCount }}</span>
          </div>
        @if (this.isIdologyDriverVerification === 'IDOLOGY') {
        <div class=" col-12" >
          <div class="grid">
            <div class="col-5">
              <div class="info-label" translate>label_verified_by_third_party</div> :
            </div>
            <div class="col-7">
              <div> {{ passengerDetails.verifiedByThirdParty }}</div>
            </div>
          </div>
        </div>
        <div class=" col-12" >
          <div class="grid">
            <div class="col-5">
              <div class="info-label" translate>label_verified_by_third_party_at</div> :
            </div>
            <div class="col-7">
              <div> {{ passengerDetails.verifiedByThirdPartyAt | date}}</div>
            </div>
          </div>

        </div>
             }

      </div>
    </div>
  </div>
</div>
</div>
<div class="panel-div" *ngIf="passengerDetails === null">
  <div class="col-12">
    <div class="info-label" translate>message_passenger_not_assigned</div>
  </div>
</div>